const state = {
    currentSlideIndex: 0
}

const mutations = {
    SET_CURRENT_SLIDE_INDEX(state, index) {
        state.currentSlideIndex = index;
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
